
import { defineComponent, watch, ref } from "vue";
import { useStore } from "vuex";
import KTBcn from "./Bcn.vue";
import KTTopbar from "./Topbar.vue";

import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from "../../core/helpers/config";

export default defineComponent({
  name: "KTHeader",
  props: {
    title: String,
  },
  components: {
    KTBcn,
    KTTopbar,
  },
  setup() {
    const store = useStore();
    const pageTitle = ref();
    const breadcrumbs = ref([]);

    pageTitle.value = store.getters.pageTitle;
    breadcrumbs.value = store.getters.pageBreadcrumbPath;

    watch(
      () => store.getters.pageTitle,
      (newVal) => {
        pageTitle.value = newVal;
      }
    );

    watch(
      () => store.getters.pageBreadcrumbPath,
      (newVal) => {
        breadcrumbs.value = newVal;
      }
    );

    return {
      pageTitle,
      breadcrumbs,
      headerWidthFluid,
      headerLeft,
      asideDisplay,
    };
  },
});
